<div class="cardbottomsec">
    <span>
        <span *ngIf="totalCount == 0">Showing 0 to 0 of {{totalCount}} entries</span>
        <span *ngIf="totalCount != 0 && (noOfPages==0 || currentPage==noOfPages-1)">Showing
            {{currentPage*pageSize+1}} to {{totalCount}} of {{totalCount}} entries</span>
        <span *ngIf="totalCount != 0 && (noOfPages!=0 && currentPage!=noOfPages-1)">Showing
            {{currentPage*pageSize+1}} to {{currentPage*pageSize+pageSize}} of {{totalCount}} entries</span>
    </span>
    <ul class="pagingSec">
        <li class="next" [class.disabled]="currentPage <=0" (click)="previousClick();"><a href="#"><i class="material-icons">keyboard_arrow_left</i></a></li>
        <li>{{currentPage+1}}/{{noOfPages}}</li>
        <li class="prev" [class.disabled]="currentPage >= totalCount/pageSize - 1" (click)="nextClick()"><a href="#"><i
                    class="material-icons">keyboard_arrow_right</i></a></li>
    </ul>
</div>